export const LUMOS_TRAINING_CONFIG_KEY = 'STR-1';
